import { Button, Center, Flex, Heading, useToast } from "@chakra-ui/react";
import { Form, FormikProvider, useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { useCreateCompany } from "../../../services/hooks/useCompanies";
import { FieldInput } from "../../components/Form/FieldInput";

export function CreateCompany() {
  const { mutate } = useCreateCompany();
  const navigate = useNavigate();
  const toast = useToast();
  const formik = useFormik({
    initialValues: {
      name: "",
    },
    onSubmit: (values, helpers) => {
      helpers.resetForm();
      mutate(values, { onSuccess, onError });
    },
  });
  const goBack = () => navigate("/dashboard/companies");
  function onSuccess() {
    toast({ title: "Companhia criada com sucesso", status: "success", position: "top-right" });
    goBack();
  }
  function onError() {
    toast({ title: "É preciso especificar um nome", status: "error", position: "top-right" });
  }
  return (
    <>
      <PageTitle title="Criar Companhia - Dashboard" />
      <Flex direction="column">
        <Heading fontSize="21" textAlign="center" mb="6">
          ADICIONAR COMPANHIA
        </Heading>
        <FormikProvider value={formik}>
          <Form>
            <FieldInput label={"Nome"} name={"name"} type="text" />
          </Form>
          <Center mt="6" gap="2">
            <Button
              as={Link}
              type="button"
              variant="ghost"
              _hover={{ color: "black", bgColor: "white" }}
              to="/dashboard/companies"
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              colorScheme={"telegram"}
              bgColor={"telegram.700"}
              onClick={() => {
                formik.handleSubmit();
              }}
            >
              Criar
            </Button>
          </Center>
        </FormikProvider>
      </Flex>
    </>
  );
}
